<template>
  <div id="task-inbox-content" v-if="task" class="panel panel-refresh pa-0">
    <div class="refresh-container">
      <div class="la-anim-1"></div>
    </div>
    <div class="panel-heading pt-20 pb-20 pl-15 pr-15">
      <div class="flex-div-center">
        <span :class="`task-${task.task_type}`">{{$t(`app.tasks.types.${task.task_type}`)}}</span>
        <span
          class="task-name"
        >{{(task.name !== undefined && task.name !== null ? (task.name + ' - ') : '' ) + task.provided_identifier}}</span>
        <a  v-if="task.deleted_at === null && loggedInUser.role !== 'vivu' && loggedInUser.role !== 'worker' && task.status !== 'done'" class="pull-right inline-block action-button">
          <i ref="dropdownOpen" class="ti-angle-down"></i>
        </a>
        <ul v-show="showDropDown" ref="dropdownMenu" class="menu">
          <li class="list">
            <a class="dd-link pointer hover-bg-moon-gray">
              <span>{{$t('app.tasks.attributes.status')}}: {{$t(`app.tasks.statuses.${task.status}`)}}</span>
            </a>
          </li>
          <li v-if="this.loggedInUser.role !== 'worker'" class="divider"></li>
          <li v-if="this.loggedInUser.role !== 'worker'" class="list" @click="sendEditTask">
            <a class="dd-link pointer hover-bg-moon-gray">
              <span>{{$t('app.tasks.options.edit')}}</span>
            </a>
          </li>
          <li class="divider" v-if="!task.deleted_at && this.loggedInUser.role !== 'worker'"></li>
          <li class="list" @click="sendDeleteTask" v-if="!task.deleted_at && this.loggedInUser.role !== 'worker'">
            <a class="dd-link pointer hover-bg-moon-gray">
              <span>{{$t('app.tasks.options.delete')}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="sender-info pull-left max-width">
        <div class="container-fluid profile-field">
          <div class="sender-img-wrap pull-left profile-avatar">
            <img :src="assigneeProfileURL" class="rounded" />
          </div>
          <div class="sender-details pull-left profile-details">
            <div>
              <span class="name-field">{{task.reporter_user.name}}</span>
              <span class="name-field-sub-text">{{$t('app.tasks.reported_by')}}</span>
              <span class="date-field pull-right">{{task.created_at | moment("YYYY-MM-DD")}}</span>
            </div>
            <span class="block">
              <span
                v-if="task.assignee_user"
                class="name-field"
              >{{$t('app.tasks.assignee')}} {{task.assignee_user.name}}</span>
            </span>
            <span class="block">
              <span
                class="name-field"
              >{{$t('app.tasks.deadline')}}: {{task.deadline | moment("YYYY-MM-DD") }}</span>
            </span>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="panel-wrapper collapse in">
      <div class="panel-body inbox-body pa-0">
        <div class="heading-inbox">
          <hr class="light-grey-hr mt-10 mb-15" />
          <div class="container-fluid mb-20">
            <!--<h4 class="weight-500"></h4>-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right pr-40">
            <base-button
              :title="$t('app.tasks.buttons.done')"
              classNames="btn btn-success button-rounded pull-right"
              @clicked="updateStatus('done')"
              v-if="isOpen"
            />
          </div>
        </div>
        <div class="container-fluid view-mail">
          <p class="task-description">"{{task.description}}"</p>
          <div class="row" v-if="task.assets.length > 0">
            <div class="col-md-12">
              <label class="task-messages-title mt-40">{{$t('app.tasks.assets')}}</label>
              <div v-for="(asset, index) in task.assets" :key="index">
                <task-asset :asset="asset" />
              </div>
            </div>
          </div>
          <div class="row" v-if="task.site_map !== undefined && task.site_map !== null">
            <div class="col-md-12">
              <label class="task-messages-title mt-40">{{$t('app.tasks.location')}}</label>
              <asset-location :imageUrl="task.site_map" :task="task" :area="task.marker_area" />
            </div>
          </div>
          <label
            v-if="task.task_messages.length > 0"
            class="task-messages-title mt-40"
          >{{$t('app.tasks.messages')}}</label>
          <div v-for="(message, index) in task.task_messages" :key="index">
            <task-message :message="message" />
          </div>
          <div v-if="task.deleted_at === null" class="text-box mt-20">
            <base-textarea
              v-model="newMessage"
              ref="messageField"
              :placeholder="$t('app.generals.inputPlaceholder')"
            />
          </div>
          <base-button
            v-if="task.deleted_at === null"
            :title="$t('app.tasks.buttons.send_message')"
            classNames="btn btn-orange button-rounded pull-left"
            @clicked="sendNewMessage"
          />
          <div v-if="task.deleted_at === null" class="status-buttons text-right">
            <router-link
              v-if="task.inspection_id !== undefined && task.inspection_id !== null"
              :to="memoLink"
            >
              <base-button
                :title="$t('app.tasks.buttons.report')"
                classNames="btn btn-primary button-rounded pull-left"
              @clicked="openMemo"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BaseButton from "@/components/shared/buttons/BaseButton";
import BaseTextarea from "@/components/shared/inputs/BaseTextArea";
import TaskMessage from "./TaskMessage";
import TaskAsset from "./TaskAsset";
import AssetLocation from "./AssetLocation";

export default {
  name: "TasksInboxListContent",
  components: {
    "base-button": BaseButton,
    "base-textarea": BaseTextarea,
    "task-message": TaskMessage,
    "task-asset": TaskAsset,
    "asset-location": AssetLocation
  },
  props: {
    task: {
      type: Object
    }
  },
  data() {
    return {
      newMessage: "",
      showDropDown: false
    };
  },
  created() {
    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  },
  computed: {
    ...mapGetters({
      loggedInUser: "loggedInUser",
    }),
    assigneeProfileURL() {
      if (
        this.task.assignee_user &&
        this.task.assignee_user.profile_image_url
      ) {
        return this.task.assignee_user.profile_image_url;
      }
      return "static/avatar.png";
    },
    memoLink() {
      return `/inspections/${this.task.inspection_id}/report`;
    },
    isOpen() {
      return this.task.status !== "done";
    }
  },
  methods: {
    openMemo(memoLink) {
      this.$router.push({path: this.memoLink})
    },
    documentClick(e) {
      let el = this.$refs["dropdownMenu"];
      let elOpener = this.$refs["dropdownOpen"];
      let target = e.target;
      if (this.showDropDown === false) {
        if (elOpener === target) {
          this.showDropDown = true;
        }
      } else {
        if (el !== target && !el.contains(target)) {
          this.showDropDown = false;
        }
      }
    },
    sendNewMessage() {
      const input = this.$refs["messageField"];
      if (this.newMessage === "" || this.newMessage === " ") {
        input.handleInput(null);
        return;
      }
      this.$emit("sendBtnClicked", {
        id: this.task.id,
        message: this.newMessage
      });
      this.newMessage = "";
      input.clearContent();
    },
    sendEditTask() {
      this.$emit("editTaskClicked", this.task.id);
    },
    sendDelegateTask() {
      this.$emit("delegateTaskClicked", this.task.id);
    },
    sendDeleteTask() {
      this.$emit("deleteTaskClicked", this.task.id);
    },
    updateStatus(status) {
      this.$swal
        .fire({
          html: this.$t(`app.tasks.finalize`),
          type: "info",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t("app.notifications.general_confirm.ok"),
          cancelButtonText: this.$t("app.notifications.general_confirm.cancel")
        })
        .then(result => {
          if (result.value) {
            this.$emit("updateStatusClicked", {
              id: this.task.id,
              status: status
            });
          }
        });
    }
  },
  watch: {
    task(newValue, oldValue) {
      this.showDropDown = false;
    }
  }
};
</script>

<style lang="scss">
#task-inbox-content {
  textarea {
    resize: none;
    width: 100%;
    height: 134px;
    padding: 15px;
    border-radius: 4px;
  }
  .button-rounded {
    border-radius: 4px;
  }
  .task-description {
    font-style: italic;
  }
  .task-messages-title {
    font-size: 18px;
  }

  .ti-angle-down {
    color: #000000;
    font-size: 10px !important;
  }
  .action-button {
    margin-left: auto !important;
    cursor: pointer;
  }
  .menu {
    position: absolute;
    top: 5%;
    right: 2%;
    z-index: 1000;
    float: left;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    border-radius: 2px;
    border: none;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.175);
    min-width: 160px;
  }

  .list {
    cursor: pointer;
    margin: 5px;
    a {
      display: flex;
      align-items: center;
      padding: 3px 20px;
      clear: both;
      font-weight: 400;
      line-height: 1.42857143;
      color: #333;
      white-space: nowrap;

      i {
        color: #000000;
        font-size: 18px;
        margin-right: 10px;
      }
    }
  }

  .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
  }

  .status-buttons {
    margin-top: 30px;
  }
  .dd-link:hover {
    font-weight: bold !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/TasksInboxListContent.vue